(function ($) {
  "use strict";
  Drupal.behaviors.header = {
    attach: function (context, settings) {
      Drupal.fixedOnScroll(context, ".wpage > header");
    },
  };

  Drupal.behaviors.language = {
    attach: function (context, settings) {
      const $languageSwitcher = $(
        once("oncedLanguage", ".language-switcher-language-url", context)
      );
      function proceedLanguageReorganization() {
        $languageSwitcher.each(function (item) {
          $languageSwitcher.find("li.is-active").off("click");
        });
        if (Drupal.is_tabletsDown()) {
          $languageSwitcher.each(function (item) {
            $languageSwitcher.find("li.is-active").click(function (e) {
              e.preventDefault();
              $(this).siblings().toggle();
              $(this).parents(".block-language").toggleClass("open");
            });
          });
        }
      }

      proceedLanguageReorganization();
      window.addEventListener(
        "resize",
        function () {
          proceedLanguageReorganization();
        },
        false
      );
    },
  };

  Drupal.behaviors.account = {
    attach: function (context, settings) {
      const $languageSwitcher = $(
        once("oncedAccount", ".menu--account", context)
      );
      if (Drupal.is_tabletsDown()) {
        $languageSwitcher.click(function () {
          $(this).toggleClass("open");
        });
      }
    },
  };

  Drupal.behaviors.mainMenu = {
    attach: function attach(context) {
      const $dropDownLinks = $(
        once(
          "oncedMainMenu",
          "header .block-menu.menu--main  .menu > li.menu-item--expanded > a,header .block-menu.menu--main  .menu > li.menu-item--expanded > span"
        ),
        context
      );

      const $menuToggleBtn = $(
        once("oncedMainMenu", "header .block-menu.menu--main", context)
      );

      $dropDownLinks.each(function (item) {
        $(this)
          .closest("li.menu-item--expanded")
          .addClass($(this).attr("class"));
      });

      function proceedMainMenuReorganization() {
        $dropDownLinks.off("click").removeClass("dropdown-open");
        $menuToggleBtn.off("click").removeClass("open-main-menu");
        $menuToggleBtn.parents("header").removeClass("header-open-main-menu");
        $menuToggleBtn
          .parents("header")
          .find(".site-logo img")
          .attr("src", "/themes/custom/passpass/logo-short.svg");
        $dropDownLinks
          .parent()
          .off("mouseenter mouseleave")
          .removeClass("dropdown-open");
        if (!Drupal.is_tabletsDown()) {
          let timer;
          $dropDownLinks.parent().hover(
            function () {
              $dropDownLinks.parent().removeClass("dropdown-open");
              $(this).addClass("dropdown-open");
              if (typeof timer !== "undefined") {
                clearTimeout(timer);
              }
            },
            function () {
              // Arrows function handle "this" differently
              timer = setTimeout(() => {
                $(this).removeClass("dropdown-open");
              }, 300);
            }
          );
        } else {
          $menuToggleBtn.click(function () {
            $(this).toggleClass("open-main-menu");
            let $header = $(this).parents("header");
            $header.toggleClass("header-open-main-menu");
            $header
              .find(".site-logo img")
              .attr("src", (_, attr) =>
                $header.hasClass("header-open-main-menu")
                  ? "/themes/custom/passpass/logo-short.svg"
                  : "/themes/custom/passpass/logo-short.svg"
              );
            
            // Empêcher le scroll du body quand le menu est ouvert sur mobile
            let $body = $("body");
            if ($(this).hasClass("open-main-menu")) {
              // Menu ouvert : sauvegarder la position de scroll et désactiver le scroll
              $body.data("scrollPosition", window.scrollY);
              $body.css({
                overflow: "hidden",
                position: "fixed",
                top: -window.scrollY + "px",
                width: "100%"
              });
            } else {
              // Menu fermé : restaurer le scroll
              let scrollPosition = $body.data("scrollPosition") || 0;
              $body.css({
                overflow: "",
                position: "",
                top: "",
                width: ""
              });
              window.scrollTo(0, scrollPosition);
            }
          });
          $menuToggleBtn.find("> .menu").click(function (e) {
            e.stopPropagation();
          });
          $dropDownLinks.click(function (e) {
            e.preventDefault();
            let $that = $(this);
            $dropDownLinks.each(function () {
              if ($that.attr("href") !== $(this).attr("href")) {
                $(this).parent().removeClass("dropdown-open");
              }
            });
            $(this).parent().toggleClass("dropdown-open");
          });
          $dropDownLinks.find("> .menu").click(function (e) {
            e.stopPropagation();
          });
        }
      }
      proceedMainMenuReorganization();
      window.addEventListener(
        "resize",
        function () {
          proceedMainMenuReorganization();
        },
        false
      );
    },
  };

  Drupal.behaviors.accountResponsiveRedirect = {
    attach: function (context, settings) {
      function updateStoreLinks() {
        document
          .querySelectorAll(".apple-store-link, .google-store-link, .apple-store-link-sub-menu, .google-store-link-sub-menu")
          .forEach(function (element) {
            element.parentNode.style.display = "none";
          });

        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // const isSafari = /^((?!chrome|android).)*safari/i.test(
        //   navigator.userAgent
        // );

        const isAndroid = /Android/i.test(navigator.userAgent);


        if ((isIOS)) {
          document
            .querySelectorAll(".apple-store-link, .apple-store-link-sub-menu")
            .forEach(function (element) {
              element.parentNode.style.display = "flex";
            });
        } else if(isAndroid) {
          document
            .querySelectorAll(".google-store-link, .google-store-link-sub-menu")
            .forEach(function (element) {
              element.parentNode.style.display = "flex";
            });
        }
      }

      window.onload = updateStoreLinks;
      window.onresize = updateStoreLinks;
    },
  };
})(jQuery, Drupal);
